import type { RouteLocationNormalized } from 'vue-router'

/**
 * Redirects denied staff/admin route attempts to the dedicated admin login destination.
 *
 * Why: `/admin/login` is the single re-entry point for unauthorized admin navigation, so users who
 * are unauthenticated or missing staff/admin flags land in one consistent location with context.
 * This utility intentionally uses the same redirect behavior across app contexts.
 *
 * @param to Target route originally requested by the user.
 * @param reason Denial reason (`unauthenticated` or `forbidden`) used for page messaging.
 * @returns A navigation redirect to `/admin/login` with original target context.
 */
export function denyStaffAdminRoute(
    to: RouteLocationNormalized,
    reason: 'unauthenticated' | 'forbidden'
): ReturnType<typeof navigateTo> {
    return navigateTo(
        {
            path: '/admin/login',
            query: {
                redirect: to.fullPath,
                reason,
            },
        },
        { replace: true }
    )
}
